import { resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_FaceDetailDialog = _resolveComponent("FaceDetailDialog")!

  return _withDirectives((_openBlock(), _createElementBlock("span", null, [
    _createVNode(_component_q_btn, _mergeProps({
      icon: "fa fa-users",
      title: "Faces"
    }, _ctx.$attrs, { onClick: _ctx.openSidebar }), {
      default: _withCtx(() => [
        _createVNode(_component_q_badge, {
          label: _ctx.post.totalFaces,
          color: "primary",
          floating: "",
          style: {"top":"-1px"}
        }, null, 8, ["label"])
      ]),
      _: 1
    }, 16, ["onClick"]),
    _createVNode(_component_FaceDetailDialog, {
      ref: "faceDetail",
      "client-id": _ctx.post.client.id,
      onViewPerson: _ctx.openPerson
    }, null, 8, ["client-id", "onViewPerson"])
  ], 512)), [
    [_vShow, _ctx.post.totalFaces && _ctx.isGranted('VIEW_PERSONS')]
  ])
}